import { Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";
import "./main.css";
import Header from "../../../components/layout/header/Header";
import "../../../components/ui/modal/modal-children-styles/modal-withdraw1.css";
import "../../../components/ui/modal/modal-children-styles/modal-payment2.css";
import { FaCreditCard, FaHeart, FaLink, FaSackDollar, FaUserCheck, FaGear } from "react-icons/fa6";
import { MdDashboard, MdLogout, MdVerifiedUser } from "react-icons/md";
import { FaRegMessage } from "react-icons/fa6";
import { GiMoneyStack } from "react-icons/gi";
import { IoWalletSharp } from "react-icons/io5";
import { useLogout } from "../../../redux/actions/authActions";
import toastManager from "../../../components/ui/toast/ToasterManager";

const NAV__ARRAY = [
  
  { id: 1, path: "dashboard", name: "My Passbook", icon: MdDashboard },
  { id: 2, path: "fund", name: "Thrifts & Savings", icon: IoWalletSharp },
  {
    id: 3,
    path: "loans/index",
    name: "Loan Applications",
    icon: FaSackDollar,
  },
  
  { id: 9, path: "profile/kyc", name: "KYC", icon: MdVerifiedUser },
  { id: 4, path: "referrals", name: "Referrals", icon: FaLink },
  { id: 5, path: "fees/dues", name: "Fees/Dues", icon: GiMoneyStack },
  { id: 6, path: "withdrawal", name: "Withdrawal", icon: FaCreditCard },
   { id: 5, path: "profile", name: "Profile", icon: FaUserCheck },
  { id: 6, path: "settings/app", name: "Settings", icon: FaGear },
  // { id: 7, path: "donation", name: "Donation", icon: FaHeart },
  // { id: 8, path: "message", name: "Message", icon: FaRegMessage },
  // { id: 10, path: "kyc", name: "KYC", icon: MdLogout },
];

function Main() {
  const navigate = useNavigate();
  const logout = useLogout();
  const [colorId, setColorId] = useState(1);
  const [active, setActive] = useState(false);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      const response = await logout();
      if (response.status === true || response.status === "success") {
        localStorage.clear();
        toastManager.addToast({
          message: "Logout successful",
          type: "success",
        });
        navigate("/");
        return;
      } else {
        toastManager.addToast({
          message: "Logout unsuccessful",
          type: "error",
        });
      }
    } catch (error) {
      localStorage.clear();
    } finally {
      localStorage.clear();
      navigate("/");
    }
  };

  return (
    <div className="admin">
      <Header handleNav={setActive} isSidebarActive={active} logout={handleLogout} />

      <div className="admin__container">
        <div className={active ? "admin__navbar active" : "admin__navbar"}>
          <section className="admin__navbar__section__two">
            {NAV__ARRAY.map((item, index) => {
              return (
                <div
                  key={index}
                  onClick={() => {
                    navigate(item.path);
                    setColorId(item.id);
                  }}
                  className={colorId === item.id ? "admin__navbar__active" : ""}
                >
                  <item.icon className="admin__navbar__icon" />
                  <h3>{item.name}</h3>
                </div>
              );
            })}
            <hr style={{background:"#BBBBBB59"}}/>
            <div
              onClick={handleLogout}
                className={"admin__navbar__icon"}
              >
                <MdLogout className="admin__navbar__icon" />
              <h3>Logout</h3>
            </div>
          </section>
         
        </div>
        <div className={active ? "admin__outlet active" : "admin__outlet"}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Main;